import {FC} from 'react';

import {useField} from 'formik';

import {TextField, MenuItem, TextFieldProps} from '@mui/material';
import {useTheme} from '@mui/material/styles';

import {getFieldStyle} from '../../layouts/theme/FieldStyles';

const FMSelect: FC<
  {
    options: {label: string; value: string}[];
    name: string;
  } & TextFieldProps
> = ({name, options, ...props}) => {
  const [field, meta, helpers] = useField(name);
  const theme = useTheme();
  const fieldStyle = getFieldStyle(theme);
  return (
    <TextField
      {...field}
      {...props}
      value={field.value ?? ''}
      onChange={(event) => {
        helpers.setValue(event.target.value);
      }}
      select
      helperText={meta.touched && meta.error ? meta.error : ''}
      error={meta.touched && Boolean(meta.error)}
      sx={{
        ...fieldStyle,
        ...props.sx,
      }}
    >
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default FMSelect;
